import React from "react";
import "../landing.css";
import styled from "styled-components";
import left from "@asset/ces/folder-icon.png";
import right from "@asset/ces/ces-icon-arrow-right.png";

const LeftIcon = styled.img`
  width: 36px;
  height: 36px;
  margin-right: 10px;
`;

const RightIcon = styled.img`
  width: 36px;
  height: 36px;
  margin-left: 10px;
`;

const MediaKitButton = ({ onClick }) => {
  React.useEffect(() => {
    // 모든 이미지 프리로드
    const images = [left, right];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const handleClick = () => {
    window.open("https://bit.ly/3DHvQho", "_blank");
  };

  return (
    <div
      className="btn_media_kit"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <LeftIcon src={left} alt="left_icon" />
      <p className="btn_media_kit_text">Media Kit</p>
      <RightIcon src={right} alt="right_icon" />
    </div>
  );
};

export default MediaKitButton;
